export type SaveNotificationType = 'success' | 'danger' | 'warning';

export const SaveNotificationTypes: Record<string, SaveNotificationType> = {
  SUCCESS: 'success',
  ERROR: 'danger',
  CONFLICT: 'warning',
};

export default SaveNotificationTypes;
